import {LinePlotSettings} from '../../../components/SettingsDrawer/types';
import {ActionType, ViewReducerState} from '../reducerSupport';
import * as Actions from './actions';
import * as Types from './types';

export const updateLinePlotSettings = (
  state: ViewReducerState,
  ref: Types.Ref,
  settings: Partial<LinePlotSettings>
): [ViewReducerState, ActionType] => {
  const newState = {
    ...state,
    parts: {
      ...state.parts,
      [ref.type]: {
        ...state.parts[ref.type],
      },
    },
  };
  const prevWorkspaceSettings = newState.parts['workspace-settings'][ref.id];

  newState.parts['workspace-settings'][ref.id] = {
    ...prevWorkspaceSettings,
    linePlot: {
      ...prevWorkspaceSettings.linePlot,
      ...settings,
    },
  };

  const inverseAction = Actions.updateLinePlotWorkspaceSettings(
    ref,
    prevWorkspaceSettings.linePlot ?? {}
  );
  return [newState, inverseAction];
};
